export default __webpack_public_path__ + "static/media/login.95b0c9b2.jpg";